module.exports = __webpack_public_path__ + "static/media/undraw_Hello_re_3evm.5ebfd012.png";